import { render, staticRenderFns } from "./LaporanJumlahBarang.vue?vue&type=template&id=4e3ed896&"
import script from "./LaporanJumlahBarang.vue?vue&type=script&lang=js&"
export * from "./LaporanJumlahBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports